import fetchWebApi from 'api/fetchWebApi';

interface Post2faEMAILPayload {
  verificationId: string;
}

interface Post2faEMAILResponse {
  codeId: string;
}

const post2faEMAILApiCall = async ({
  verificationId,
}: Post2faEMAILPayload): Promise<Post2faEMAILResponse> => {
  const data = await fetchWebApi('/2fa/EMAIL', undefined, {
    method: 'post',
    headers: {
      'X-Verification-Id': verificationId,
    },
  });
  return {
    codeId: data.codeId,
  };
};

export default post2faEMAILApiCall;
